export type FamilyHistoryRelationship = 'maternal' | 'nuclear' | 'paternal';

export const relationships: Record<FamilyHistoryRelationship, string[]> = {
  nuclear: [
    'CHILD',
    'DAUC',
    'DAU',
    'NCHILD',
    'SON',
    'SONC',
    'SIB',
    'BRO',
    'HBRO',
    'NBRO',
    'TWINBRO',
    'FTWINBRO',
    'ITWINBRO',
    'HSIB',
    'HSIS',
    'NSIB',
    'NSIS',
    'TWINSIS',
    'FTWINSIS',
    'ITWINSIS',
    'TWIN',
    'FTWIN',
    'ITWIN',
    'SIS',
    'NPRN',
    'PRN',
    'DOMPART',
    'FMRSPS',
    'HUSB',
    'SIGOTHR',
    'SPS',
    'WIFE',
  ],
  maternal: [
    'MAUNT',
    'MCOUSN',
    'MGGRFTH',
    'MGGRMTH',
    'MGGRPRN',
    'MGRFTH',
    'MGRMTH',
    'MGRPRN',
    'MUNCLE',
    'MTH',
    'GESTM',
    'NMTH',
    'NMTHF',
  ],
  paternal: [
    'PAUNT',
    'PCOUSN',
    'PGGRFTH',
    'PGGRMTH',
    'PGGRPRN',
    'PGRFTH',
    'PGRMTH',
    'PGRPRN',
    'PUNCLE',
    'FTH',
    'NFTH',
    'NFTHF',
  ],
};
